<template>
    <div>
        <el-form :model="from" ref="ruleForm" style="padding: 0 10%;" label-width="30%">
            <el-form-item label="组织架构" style="margin-left:-80px">
                <el-cascader v-model="ruleForm.organize_id" clearable style="margin-left:1px;width:100%" collapse-tags
                    :props="props"></el-cascader>
            </el-form-item>
            <el-form-item label="开始时间" style="margin-left:-80px">
                <el-input type="number" v-model="ruleForm.start_date" placeholder="请输入开始时间"></el-input>
            </el-form-item>
            <el-form-item label="结束时间" style="margin-left:-80px">
                <el-input type="number" v-model="ruleForm.end_date" placeholder="请输入结束时间"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="save"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">
                    保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //组织架构数据
            organizeList: [],
            //职位数据
            postList: [],
            //年龄范围数据
            ageList: [],
            ruleForm: {
                id: '',
                organize_id: [],
                start_date: '',
                end_date: '',
            },
            time: '',

            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: false,
            },
        }
    },
    methods: {
        async save() {
            console.log(this.ruleForm);
            if (this.ruleForm.organize_id.length == 0) {
                this.$message.error('请选择组织架构！');
            } else if (this.ruleForm.start_date == '') {
                this.$message.error('请选择开始时间！');
            } else if (this.ruleForm.end_date == '') {
                this.$message.error('请选择结束时间！');
            } else {
                var url = '';
                var record = {
                    organize_id: this.ruleForm.organize_id,
                    start_date: this.ruleForm.start_date,
                    end_date: this.ruleForm.end_date,
                };
                if (this.ruleForm.id) {
                    record.id = this.ruleForm.id
                    url = 'BonusModifyDate/updatePremiumTable'
                } else {
                    url = 'BonusModifyDate/insertPremiumTable'
                }
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.$parent.$parent.Return();
                        this.trash();
                    } else {
                        this.$message.warning(data);
                        this.trash();
                    }
                }
            }
        },
        async Update() {
            var url = 'BonusModifyDate/updatePremiumTable';
            var record = {
                id: this.ruleForm.id,
                organize_id: this.ruleForm.organize_id,
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.$message.success(data);
                    this.$parent.$parent.Return();
                    this.trash();
                } else {
                    this.$message.warning(data);
                }
            }
        },
        //清除数据
        trash() {
            this.ruleForm.id = '';
            this.ruleForm.organize_id = '';
            this.ruleForm.start_date = '';
            this.ruleForm.end_date = '';
        },
    },
    async created() {
        this.ruleForm = this.$parent.$parent.ruleForm;
        var postList = await this.$globals.AxiosPost('organize/findHierarchy', {});
        this.postList = postList.data;
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// tab1_add.vue?0cbdc8a4